<template>
  <b-row>
    <b-col class="flex f-center" v-if="!only_submit">
      <b-link class="blinki-close-btn" @click="$bvModal.hide(modal_name)">Annuler</b-link>
    </b-col>
    <b-col class="f-center">
      <b-button class="blinki-submit-btn" :disabled="formInvalid" type="submit" variant="primary">
        {{showenTitle}}
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    name: "save-btn-container",
    props: ['modal_name', 'valid','only_submit','title'],
    computed: {
      formInvalid() {
        return this.valid === undefined ? false : !this.valid;
      },
      showenTitle() {
        return this.title ? this.title : "Enregistrer"
      }
    }
  }
</script>

<style scoped>
.f-center{
  align-self: center;
}
</style>
